import type { ImgHTMLAttributes } from 'react'

type ImgSrcSetAttributes = Pick<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'srcSet'
>

export type ResponsiveImageSources = { x1: string; x2: string }

export const getImgSrcSetAttributes = ({
  x1,
  x2,
}: ResponsiveImageSources): ImgSrcSetAttributes => ({
  src: x1,
  srcSet: `${x1} 1x, ${x2} 2x`,
})
